import { Radio as MuiRadio, RadioProps as MuiRadioProps } from '@mui/material';
import React from 'react';

export interface RadioProps extends MuiRadioProps {}

export const Radio = (props: RadioProps) => <MuiRadio {...props} />;
